// frontend/src/components/Manual/diagrams/DiagramBox.tsx

import React from 'react';

export interface DiagramStep {
  icon?: string;
  label: string;
}

interface Props {
  title?: string;
  steps: DiagramStep[];
}

/**
 * Diagrama vertical em SVG.
 * Renderiza cada step como uma caixa, com setas entre elas.
 */
export const DiagramBox: React.FC<Props> = ({ title, steps }) => {
  const boxWidth = 260;
  const boxHeight = 44;
  const gap = 26;
  const paddingX = 20;
  const paddingY = 20;
  const svgWidth = boxWidth + paddingX * 2;

  const totalHeight =
    paddingY * 2 +
    steps.length * boxHeight +
    (steps.length - 1) * gap;

  const boxX = paddingX;

  return (
    <div className="diagram-box">
      {title && <div className="diagram-title">{title}</div>}

      <svg
        width="100%"
        viewBox={`0 0 ${svgWidth} ${totalHeight}`}
        xmlns="http://www.w3.org/2000/svg"
        role="img"
        aria-label={title || 'Diagrama de fluxo'}
      >
        <defs>
          <marker
            id="arrow"
            viewBox="0 0 10 10"
            refX="8"
            refY="5"
            markerWidth="6"
            markerHeight="6"
            orient="auto-start-reverse"
          >
            <path d="M 0 0 L 10 5 L 0 10 z" fill="#4fc3f7" />
          </marker>
        </defs>

        {steps.map((step, index) => {
          const y = paddingY + index * (boxHeight + gap);

          return (
            <g key={index}>
              {/* Caixa */}
              <rect
                x={boxX}
                y={y}
                width={boxWidth}
                height={boxHeight}
                rx="8"
                ry="8"
                fill="rgba(15, 42, 74, 0.4)"
                stroke="#1a4a7a"
                strokeWidth="1.5"
              />

              {/* Ícone */}
              {step.icon && (
                <text
                  x={boxX + 18}
                  y={y + boxHeight / 2 + 1}
                  fontSize="18"
                  textAnchor="middle"
                  dominantBaseline="middle"
                >
                  {step.icon}
                </text>
              )}

              {/* Label */}
              <text
                x={step.icon ? boxX + 42 : boxX + boxWidth / 2}
                y={y + boxHeight / 2 + 1}
                fontSize="14"
                fill="#e0e0e0"
                textAnchor={step.icon ? 'start' : 'middle'}
                dominantBaseline="middle"
                fontWeight="500"
              >
                {step.label}
              </text>

              {/* Seta para o próximo */}
              {index < steps.length - 1 && (
                <line
                  x1={boxX + boxWidth / 2}
                  y1={y + boxHeight + 4}
                  x2={boxX + boxWidth / 2}
                  y2={y + boxHeight + gap - 4}
                  stroke="#4fc3f7"
                  strokeWidth="1.5"
                  markerEnd="url(#arrow)"
                />
              )}
            </g>
          );
        })}
      </svg>
    </div>
  );
};